import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ProgressBarComponent } from "../../../design-system/progress-bar/progress-bar.component";
import { ProgressBarConfig } from "../../../design-system/progress-bar/progress-bar.modal";

@Component({
    selector: 'progress-bar-renderer',
    templateUrl: './progress-bar-renderer.component.html',
    standalone: true,
    imports: [CommonModule, ProgressBarComponent]
})
export class ProgressBarRendererComponent implements ICellRendererAngularComp {
    public total: number = 0;
    public value: number = 0;
    public isCompleted: boolean = false;
    public isPrgressValue: boolean = true;
    public progressConfig: ProgressBarConfig = {
        id: "eod-progress-bar",
        type: "",
        progressValue: 0,
    };

    initilize(params: ICellRendererParams) {
        let data = params.getValue();
        const progressType = (params as any).progressType ?? params?.colDef?.headerComponentParams?.progressType;
        if (data) {
            if (data.total && data.value) {
                this.total = data.total;
                this.value = data.value;
                if (this.value == this.total) {
                    this.isCompleted = true;
                }
                this.progressConfig = { ...this.progressConfig, progressValue: (this.value / this.total) * 100, type: progressType };
            }
            else {
                this.progressConfig = { ...this.progressConfig, progressValue: data, type: progressType };
            }
        }
    }

    get progressValueTextClass(): string {
        switch (this.progressConfig.type) {
            case '1':
                return 'text-orange';
            case '2':
                return 'text-success';
            case '3':
                return 'text-error';
            default:
                return '';
        }
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}